import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Legacy upload-link redirect.
 *
 * Emails sent before we moved the public-upload page onto `/api/upload/{id}`
 * contained links to `/upload/{id}`. On the Emergent ingress those paths
 * fall through to the React SPA (only `/api/*` is proxied to FastAPI), so
 * they used to 404. This component forwards the browser to the correct
 * backend URL so any legacy email link keeps working.
 */
export default function UploadRedirect() {
  const { orderId } = useParams();
  useEffect(() => {
    if (orderId) {
      window.location.replace(`/api/upload/${orderId}`);
    }
  }, [orderId]);
  return (
    <div style={{ padding: 40, fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
      <p>Redirecting to secure upload page…</p>
    </div>
  );
}
